import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37a462d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "QuestionRenderPageContainer brd2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CubeComplementRender = _resolveComponent("CubeComplementRender");
  const _component_GroundPerspectiveRender = _resolveComponent("GroundPerspectiveRender");
  const _component_FillWallRender = _resolveComponent("FillWallRender");
  const _component_BlockRotateRender = _resolveComponent("BlockRotateRender");
  const _component_LogicalReasoningRender = _resolveComponent("LogicalReasoningRender");
  const _component_OpticalPathInferenceRender = _resolveComponent("OpticalPathInferenceRender");
  const _component_DNASequenceRender = _resolveComponent("DNASequenceRender");
  const _component_ColorGridMemoryRender = _resolveComponent("ColorGridMemoryRender");
  const _component_ImageSequenceMemoryRender = _resolveComponent("ImageSequenceMemoryRender");
  const _component_HanoiTowerInferenceRender = _resolveComponent("HanoiTowerInferenceRender");
  const _component_ColorHeightProjectionRender = _resolveComponent("ColorHeightProjectionRender");
  const _component_NineGridMirrorInferenceRender = _resolveComponent("NineGridMirrorInferenceRender");
  const _component_MechanicalArmPoseRender = _resolveComponent("MechanicalArmPoseRender");
  const _component_LogicalReasoning2DRender = _resolveComponent("LogicalReasoning2DRender");
  const _component_TextLogicalReasoningRender = _resolveComponent("TextLogicalReasoningRender");
  const _component_PlaneTurntableRender = _resolveComponent("PlaneTurntableRender");
  const _component_StereoSameEdgeRender = _resolveComponent("StereoSameEdgeRender");
  const _component_GraphMatchRender = _resolveComponent("GraphMatchRender");
  const _component_CircuitRoutingRender = _resolveComponent("CircuitRoutingRender");
  const _component_LogicalTransformerSectorRender = _resolveComponent("LogicalTransformerSectorRender");
  const _component_Unfolding3DRender = _resolveComponent("Unfolding3DRender");
  const _component_FlashDiamondRender = _resolveComponent("FlashDiamondRender");
  const _component_BlackWhiteDotRender = _resolveComponent("BlackWhiteDotRender");
  const _component_ImageTransformRender = _resolveComponent("ImageTransformRender");
  const _component_WhackAMoleRender = _resolveComponent("WhackAMoleRender");
  const _component_E808APlusRender = _resolveComponent("E808APlusRender");
  const _component_E808ARender = _resolveComponent("E808ARender");
  const _component_MossRender = _resolveComponent("MossRender");
  const _component_MossCopyRender = _resolveComponent("MossCopyRender");
  const _component_E808ERender = _resolveComponent("E808ERender");
  const _component_E808EPlusRender = _resolveComponent("E808EPlusRender");
  const _component_QuickScaleRender = _resolveComponent("QuickScaleRender");
  const _component_CodeMathRender = _resolveComponent("CodeMathRender");
  const _component_FastMemoryRender = _resolveComponent("FastMemoryRender");
  const _component_SeesawRender = _resolveComponent("SeesawRender");
  const _component_PriceCalculateRender = _resolveComponent("PriceCalculateRender");
  const _component_RandomForestRender = _resolveComponent("RandomForestRender");
  const _component_LogicalTransformer2D = _resolveComponent("LogicalTransformer2D");
  const _component_F3DScaleARender = _resolveComponent("F3DScaleARender");
  const _component_F3DScaleBRender = _resolveComponent("F3DScaleBRender");
  const _component_F3DScaleCRender = _resolveComponent("F3DScaleCRender");
  const _component_TaiChiARender = _resolveComponent("TaiChiARender");
  const _component_TaiChiBRender = _resolveComponent("TaiChiBRender");
  const _component_E808BRender = _resolveComponent("E808BRender");
  const _component_E808B2Render = _resolveComponent("E808B2Render");
  const _component_E808DRender = _resolveComponent("E808DRender");
  const _component_E808CRender = _resolveComponent("E808CRender");
  const _component_E808D2Render = _resolveComponent("E808D2Render");
  const _component_E808B3Render = _resolveComponent("E808B3Render");
  const _component_FlashBoxRender = _resolveComponent("FlashBoxRender");
  const _component_DiceRender = _resolveComponent("DiceRender");
  const _component_NineGridRender = _resolveComponent("NineGridRender");
  const _component_CSGItem = _resolveComponent("CSGItem");
  const _component_StereoProjectionRender = _resolveComponent("StereoProjectionRender");
  const _component_StereoscopicSectionExamRender = _resolveComponent("StereoscopicSectionExamRender");
  const _component_MemoryNumbersRender = _resolveComponent("MemoryNumbersRender");
  const _component_GraphicalReasoningRender = _resolveComponent("GraphicalReasoningRender");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  return $data.session ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$props.subject == 'CubeComplement' ? (_openBlock(), _createBlock(_component_CubeComplementRender, {
    key: 0,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0],
    runtimeParams: $data.session.runtimeParams
  }, null, 8, ["difficulty", "onAnswer", "data", "runtimeParams"])) : _createCommentVNode("", true), $props.subject == 'GroundPerspective' ? (_openBlock(), _createBlock(_component_GroundPerspectiveRender, {
    key: 1,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0],
    runtimeParams: $data.session.runtimeParams
  }, null, 8, ["difficulty", "onAnswer", "data", "runtimeParams"])) : _createCommentVNode("", true), $props.subject == 'FillWall' ? (_openBlock(), _createBlock(_component_FillWallRender, {
    key: 2,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0],
    runtimeParams: $data.session.runtimeParams
  }, null, 8, ["difficulty", "onAnswer", "data", "runtimeParams"])) : _createCommentVNode("", true), $props.subject == 'BlockRotate' ? (_openBlock(), _createBlock(_component_BlockRotateRender, {
    key: 3,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0],
    runtimeParams: $data.session.runtimeParams
  }, null, 8, ["difficulty", "onAnswer", "data", "runtimeParams"])) : _createCommentVNode("", true), $props.subject == 'LogicalReasoning' ? (_openBlock(), _createBlock(_component_LogicalReasoningRender, {
    key: 4,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'OpticalPathInference' ? (_openBlock(), _createBlock(_component_OpticalPathInferenceRender, {
    key: 5,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'DNASequence' ? (_openBlock(), _createBlock(_component_DNASequenceRender, {
    key: 6,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'ColorGridMemory' ? (_openBlock(), _createBlock(_component_ColorGridMemoryRender, {
    key: 7,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'ImageSequenceMemory' ? (_openBlock(), _createBlock(_component_ImageSequenceMemoryRender, {
    key: `image-memory-${$data.session.current}`,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'HanoiTowerInference' ? (_openBlock(), _createBlock(_component_HanoiTowerInferenceRender, {
    key: 9,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'ColorHeightProjection' ? (_openBlock(), _createBlock(_component_ColorHeightProjectionRender, {
    key: 10,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'NineGridMirrorInference' ? (_openBlock(), _createBlock(_component_NineGridMirrorInferenceRender, {
    key: 11,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'MechanicalArmPose' ? (_openBlock(), _createBlock(_component_MechanicalArmPoseRender, {
    key: 12,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'LogicalReasoning2D' ? (_openBlock(), _createBlock(_component_LogicalReasoning2DRender, {
    key: 13,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'TextLogicalReasoning' ? (_openBlock(), _createBlock(_component_TextLogicalReasoningRender, {
    key: 14,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'PlaneTurntable' ? (_openBlock(), _createBlock(_component_PlaneTurntableRender, {
    key: 15,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'StereoSameEdge' ? (_openBlock(), _createBlock(_component_StereoSameEdgeRender, {
    key: 16,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'GraphMatch' ? (_openBlock(), _createBlock(_component_GraphMatchRender, {
    key: 17,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'CircuitRouting' ? (_openBlock(), _createBlock(_component_CircuitRoutingRender, {
    key: 18,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'LogicalTransformerSector' ? (_openBlock(), _createBlock(_component_LogicalTransformerSectorRender, {
    key: 19,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    question: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "question"])) : _createCommentVNode("", true), $props.subject == 'LogicalTransformerSectorPlus' ? (_openBlock(), _createBlock(_component_LogicalTransformerSectorRender, {
    key: 20,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    question: $data.session.list[0],
    plus: ""
  }, null, 8, ["difficulty", "onAnswer", "question"])) : _createCommentVNode("", true), $props.subject == 'Unfolding3D' ? (_openBlock(), _createBlock(_component_Unfolding3DRender, {
    key: 21,
    difficulty: $data.session.difficultySetting,
    idx: $data.session.current,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "idx", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'FlashDiamond' ? (_openBlock(), _createBlock(_component_FlashDiamondRender, {
    key: 22,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'BlackWhiteDot' ? (_openBlock(), _createBlock(_component_BlackWhiteDotRender, {
    key: 23,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'ImageTransform' ? (_openBlock(), _createBlock(_component_ImageTransformRender, {
    key: 24,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'WhackAMole' ? (_openBlock(), _createBlock(_component_WhackAMoleRender, {
    key: 25,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'E808APlus' ? (_openBlock(), _createBlock(_component_E808APlusRender, {
    key: 26,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'E808A' ? (_openBlock(), _createBlock(_component_E808ARender, {
    key: 27,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'Moss' || $props.subject == 'HarderMoss' || $props.subject == 'Moss5' ? (_openBlock(), _createBlock(_component_MossRender, {
    key: 28,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'MossCopy' || $props.subject == 'MossMissing4' || $props.subject == 'MossMissing5' ? (_openBlock(), _createBlock(_component_MossCopyRender, {
    key: 29,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'E808E' ? (_openBlock(), _createBlock(_component_E808ERender, {
    key: 30,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'E808EPlus' ? (_openBlock(), _createBlock(_component_E808EPlusRender, {
    key: 31,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'QuickScale' ? (_openBlock(), _createBlock(_component_QuickScaleRender, {
    key: 32,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'CodeMath' ? (_openBlock(), _createBlock(_component_CodeMathRender, {
    key: 33,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'FastMemory' ? (_openBlock(), _createBlock(_component_FastMemoryRender, {
    key: 34,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'Seesaw' ? (_openBlock(), _createBlock(_component_SeesawRender, {
    key: 35,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'PriceCalculate' ? (_openBlock(), _createBlock(_component_PriceCalculateRender, {
    key: 36,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'RandomForest' ? (_openBlock(), _createBlock(_component_RandomForestRender, {
    key: 37,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0],
    runtimeParams: $data.session.runtimeParams
  }, null, 8, ["difficulty", "onAnswer", "data", "runtimeParams"])) : _createCommentVNode("", true), $props.subject == 'LogicalTransformer2D' ? (_openBlock(), _createBlock(_component_LogicalTransformer2D, {
    onAnswer: $options.onAnswer,
    question: $data.session.list[0],
    key: `LogicalTransformer2D_${$data.session.current}`
  }, null, 8, ["onAnswer", "question"])) : _createCommentVNode("", true), $props.subject == 'F3DScaleA' ? (_openBlock(), _createBlock(_component_F3DScaleARender, {
    onAnswer: $options.onAnswer,
    question: $data.session.list[0],
    key: `F3DScaleA_${$data.session.current}`
  }, null, 8, ["onAnswer", "question"])) : _createCommentVNode("", true), $props.subject == 'F3DScaleB' ? (_openBlock(), _createBlock(_component_F3DScaleBRender, {
    onAnswer: $options.onAnswer,
    question: $data.session.list[0],
    key: `F3DScaleB_${$data.session.current}`
  }, null, 8, ["onAnswer", "question"])) : _createCommentVNode("", true), $props.subject == 'F3DScaleC' ? (_openBlock(), _createBlock(_component_F3DScaleCRender, {
    onAnswer: $options.onAnswer,
    question: $data.session.list[0],
    key: `F3DScaleC_${$data.session.current}`
  }, null, 8, ["onAnswer", "question"])) : _createCommentVNode("", true), $props.subject == 'TaiChiA' ? (_openBlock(), _createBlock(_component_TaiChiARender, {
    onAnswer: $options.onAnswer,
    question: $data.session.list[0],
    key: `TaiChiA_${$data.session.current}`
  }, null, 8, ["onAnswer", "question"])) : _createCommentVNode("", true), $props.subject == 'TaiChiB' ? (_openBlock(), _createBlock(_component_TaiChiBRender, {
    onAnswer: $options.onAnswer,
    question: $data.session.list[0],
    key: `TaiChiB_${$data.session.current}`
  }, null, 8, ["onAnswer", "question"])) : _createCommentVNode("", true), $props.subject == 'E808B' ? (_openBlock(), _createBlock(_component_E808BRender, {
    key: 44,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list.slice(0, $props.groupSize)
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'E808B2' ? (_openBlock(), _createBlock(_component_E808B2Render, {
    key: 45,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list.slice(0, $props.groupSize)
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'E808D' ? (_openBlock(), _createBlock(_component_E808DRender, {
    key: 46,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list.slice(0, $props.groupSize)
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'E808C' ? (_openBlock(), _createBlock(_component_E808CRender, {
    key: 47,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list.slice(0, $props.groupSize)
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'E808D2' ? (_openBlock(), _createBlock(_component_E808D2Render, {
    key: 48,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list.slice(0, $props.groupSize)
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'E808B3' || $props.subject == 'E808B4' ? (_openBlock(), _createBlock(_component_E808B3Render, {
    key: 49,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list.slice(0, $props.groupSize)
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'FlashingRect' ? (_openBlock(), _createBlock(_component_FlashBoxRender, {
    key: 50,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'RandomDice' ? (_openBlock(), _createBlock(_component_DiceRender, {
    key: 51,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0],
    runtimeParams: $data.session.runtimeParams
  }, null, 8, ["difficulty", "onAnswer", "data", "runtimeParams"])) : _createCommentVNode("", true), $props.subject == 'RotateMatrix' ? (_openBlock(), _createBlock(_component_NineGridRender, {
    key: 52,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'ColorRotateMatrix' ? (_openBlock(), _createBlock(_component_NineGridRender, {
    key: 53,
    subject: "NineGridColor",
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["difficulty", "onAnswer", "data"])) : _createCommentVNode("", true), $props.subject == 'StereoscopicSection' ? (_openBlock(), _createBlock(_component_CSGItem, {
    key: 54
  })) : _createCommentVNode("", true), $props.subject == 'StereoProjection' ? (_openBlock(), _createBlock(_component_StereoProjectionRender, {
    key: 55,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0],
    runtimeParams: $data.session.runtimeParams
  }, null, 8, ["onAnswer", "data", "runtimeParams"])) : _createCommentVNode("", true), $props.subject == 'StereoscopicSectionExam' ? (_openBlock(), _createBlock(_component_StereoscopicSectionExamRender, {
    key: 56,
    data: $data.session.list[0],
    onAnswer: $options.onAnswer,
    runtimeParams: $data.session.runtimeParams
  }, null, 8, ["data", "onAnswer", "runtimeParams"])) : $props.subject == 'SequenceBacktracking' ? (_openBlock(), _createBlock(_component_MemoryNumbersRender, {
    key: 57,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0]
  }, null, 8, ["onAnswer", "data"])) : $props.subject == 'NeuralNetwork' ? (_openBlock(), _createBlock(_component_GraphicalReasoningRender, {
    key: 58,
    difficulty: $data.session.difficultySetting,
    onAnswer: $options.onAnswer,
    data: $data.session.list[0],
    runtimeParams: $data.session.runtimeParams
  }, null, 8, ["difficulty", "onAnswer", "data", "runtimeParams"])) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12,
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_createTextVNode("   ")]),
      _: 1
    }), $props.subject !== 'StereoscopicSection' && $props.subject !== 'FlashingRect' ? (_openBlock(), _createBlock(_component_el_col, {
      key: 0,
      span: 12,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$data.session.current + $props.groupSize >= $data.session.total ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        style: {
          "background": "#F53F3F",
          "color": "white",
          "border": "none",
          "width": "100px"
        },
        disabled: $data.answer == null,
        onClick: $options.submitAndNext
      }, {
        default: _withCtx(() => [_createTextVNode("交卷 ")]),
        _: 1
      }, 8, ["disabled", "onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        type: "primary",
        style: {
          "width": "100px"
        },
        disabled: $data.answer == null,
        onClick: $options.submitAndNext
      }, {
        default: _withCtx(() => [_createTextVNode("下一" + _toDisplayString($props.groupSize > 1 ? '组' : '题'), 1)]),
        _: 1
      }, 8, ["disabled", "onClick"]))]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  })])) : _createCommentVNode("", true);
}